import Vue from "vue"
import axios from "../plugins/axios"
import moment from "moment-timezone"
import _ from 'lodash'

Vue.prototype.$http = axios
Vue.prototype.$moment = moment

const getDefaultState = () => {
    return {
        cadhConfig: {},
        currentStep: 1,
        optionModal: false,
        offerModal: false,
        usedInCampaign: false,
        informationModal: false,
        searchName: null,
        configOptions: [],
        configInformations: [],
        configOffers: [],
        modalCurrentStep: 1,
        levelModal: false,
        paymentOptionModal: false,
        optionLevels: [],
        paymentOptions: [],
        criteriaFamilies: [],
        parameterCurrentStep: 1,
        type: null,
        formTitle: "",
        txtIntro: "",
        thanksText: "",
        extraMsg: '',
        offerTitle: '',
        offerHelp1: '',
        offerHelp2: '',
        optionTitle: '',
        globalFields: [],
        administrativeDatas: [],
        emailObject: '',
        emailPart1: '',
        emailPart2: '',
        cguName: '',
        cguEndText: '',
        cadhTitleInterfacePro: null,
        oneOfferToShowOptions: null,
        oneOfferToShowInformations: null,
        pdfTitle: '',
        criteriasFilter: [],
        deleteCriteriaInProgress: false,
        name: '',
        hasOffersEnabled: false,
        isConfigured: false,
        hasPaymentOptionsEnabled: false,
        hasCriteriaFamiliesWithNoName: false,
        hasCriteriasWithNoName: false,
        hasThanksEmailSet: false,
        missingRequiredDatasCount: 0,
    }
}

function getConfigValue(key) {
    let value = null
    let config = cadhConfig.state.cadhConfig.configuration_keys.find(conf => conf.key === key)

    if (config !== undefined && config !== null) {
        value = config.value
    }

    return value
}

function getAdminConfig(code) {
    return cadhConfig.state.cadhConfig.cadh_fields.find(conf => conf.code === code)
}

function missingRequiredDatasCountCalculation() {
    let count = 0

    if(!cadhConfig.state.isConfigured) {

        if(!cadhConfig.state.hasOffersEnabled) {
            count ++
        }

        if(!cadhConfig.state.hasPaymentOptionsEnabled) {
            count ++
        }

        if(!cadhConfig.state.hasThanksEmailSet) {
            count ++
        }

        if(cadhConfig.state.criteriaFamilies.length > 0  && cadhConfig.state.hasCriteriaFamiliesWithNoName) {
            count ++
        }

        if(cadhConfig.state.criteriaFamilies.length > 0 && cadhConfig.state.hasCriteriasWithNoName) {
            count ++
        }
    }

    return count
}

const cadhConfig = {
    namespaced: true,
    state: getDefaultState(),
    getters: {},
    mutations: {
        setCadhConfig(state, data) {
            state.cadhConfig = data
        },
        setCurrentStep(state, value) {
            state.currentStep = value
        },
        setOptionModal(state, value) {
            state.optionModal = value
        },
        setUsedInCampaign(state, value) {
            state.usedInCampaign = value
        },
        setInformationModal(state, value) {
            state.informationModal = value
        },
        setOfferModal(state, value) {
            state.offerModal = value
        },
        setSearchName(state, value) {
            state.searchName = value
        },
        setConfigOptions(state, value) {
            const options = value

            options.forEach(option => {
                Vue.set(option, 'selected', false)
            })

            state.configOptions = options
        },
        setConfigInformations(state, value) {
            const informations = value

            informations.forEach(information => {
                Vue.set(information, 'selected', false)
            })

            state.configInformations = informations
        },
        setConfigOffers(state, value) {
            const offers = value

            offers.forEach(offer => {
                Vue.set(offer, 'selected', false)
            })

            state.configOffers = offers
        },
        setOptionLevels(state, value) {
            state.optionLevels = value
        },
        setCriteriaFamilies(state, families) {
            families.forEach(family => {
                Vue.set(family, 'isDirty', family.label === null || family.label === '')

                family.criterias.forEach(criteria => {
                    Vue.set(criteria, 'isDirty', criteria.label === null || criteria.label === '')
                })
            })

            state.criteriaFamilies = families
        },
        setNewFamilyIsDirty(state, order) {
            state.criteriaFamilies.forEach(family => {
                if (family.order === order) {
                    Vue.set(family, 'isDirty', false)
                }
            })
        },
        setNewCriteriaIsDirty(state, [familyId, order]) {
          state.criteriaFamilies.forEach(family => {
              if(family.id === familyId) {
                  family.criterias.forEach(criteria => {
                      if(criteria.order === order) {
                          Vue.set(criteria, 'isDirty', false)
                      }
                  })
              }
          })
        },
        updateFamilyCriterias(state, [value, familyId]) {
            state.criteriaFamilies.forEach(family => {
                if (family.id === familyId) {
                    family.criterias = value
                }
            })
        },
        setPaymentOptions(state, value) {
            state.paymentOptions = value
        },
        setModalCurrentStep(state, value) {
            state.modalCurrentStep = value
        },
        setLevelModal(state, value) {
            state.levelModal = value
        },
        setPaymentOptionModal(state, value) {
            state.paymentOptionModal = value
        },
        setParameterCurrentStep(state, value) {
            state.parameterCurrentStep = value
        },
        setglobalFields(state, value) {
            state.globalFields = value
        },
        setAdministrativeDatas(state, value) {
            state.administrativeDatas = value
        },
        setType(state, value) {
            state.type = value
        },
        setFormTitle(state, value) {
            state.formTitle = value
        },
        setTxtIntro(state, value) {
            state.txtIntro = value
        },
        setThanksTxt(state, value) {
            state.thanksText = value
        },
        setExtraMsg(state, value) {
            state.extraMsg = value
        },
        setOfferTitle(state, value) {
            state.offerTitle = value
        },
        setOfferHelp1(state, value) {
            state.offerHelp1 = value
        },
        setOfferHelp2(state, value) {
            state.offerHelp2 = value
        },
        setOptionTitle(state, value) {
            state.optionTitle = value
        },
        setEmailObject(state, value) {
            state.emailObject = value
        },
        setEmailPart1(state, value) {
            state.emailPart1 = value
        },
        setEmailPart2(state, value) {
            state.emailPart2 = value
        },
        setCguName(state, value) {
            state.cguName = value
        },
        setCguEndText(state, value) {
            state.cguEndText = value
        },
        setCadhTitleInterfacePro(state, value) {
            state.cadhTitleInterfacePro = value
        },
        setOneOfferToShowOptions(state, value) {
            state.oneOfferToShowOptions = value
        },
        setOneOfferToShowInformations(state, value) {
            state.oneOfferToShowInformations = value
        },
        setPdfTitle(state, value) {
            state.pdfTitle = value
        },
        setCriteriasFilter(state, value) {
            state.criteriasFilter = value
        },
        setDeleteCriteriaInProgress(state, value) {
          state.deleteCriteriaInProgress = value
        },
        setName(state, value) {
          state.name = value
        },
        setHasOffersEnabled(state, value) {
            state.hasOffersEnabled = value
        },
        setIsConfigured(state, value) {
          state.isConfigured = value
        },
        setHasPaymentOptionsEnabled(state, value) {
          state.hasPaymentOptionsEnabled = value
        },
        setHasCriteriaFamiliesWithNoName(state, value) {
            state.hasCriteriaFamiliesWithNoName = value
        },
        setHasCriteriasWithNoName(state, value) {
          state.hasCriteriasWithNoName = value
        },
        setHasThanksEmailSet(state, value) {
          state.hasThanksEmailSet = value
        },
        setMissingRequiredDatasCount(state, value) {
          state.missingRequiredDatasCount = value
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
    },
    actions: {
        getCadhConfig({commit}, configId) {
            return Vue.prototype.$http.get("adhesion/config/" + configId).then(
                (res) => {
                    let config = res.body.data.config
                    let usedInCampaign = res.body.data.usedInCampaign

                    commit("setCadhConfig", config)
                    commit("setUsedInCampaign", usedInCampaign)
                    commit("setConfigOptions", config.options)
                    commit("setConfigInformations", config.informations)
                    commit("setConfigOffers", config.offers)
                    commit("setOptionLevels", config.option_levels)
                    commit("setPaymentOptions", config.payment_options)
                    commit("setCriteriaFamilies", _.sortBy(config.criteria_families, (family) => family.order))
                    commit("setType", getConfigValue("global_partenariat") === "1" ? "1" : "0")
                    commit("setFormTitle", getConfigValue("titre_general"))
                    commit('setTxtIntro', getConfigValue('introduction'))
                    commit("setThanksTxt", getConfigValue('remerciement_1'))
                    commit("setExtraMsg", getConfigValue('extra_field_title'))
                    commit('setOfferTitle', getConfigValue('offres_titre_complement'))
                    commit('setOfferHelp1', getConfigValue('offres_aide_1'))
                    commit('setOfferHelp2', getConfigValue('offres_aide_2'))
                    commit('setOptionTitle', getConfigValue('options_titre_complement'))
                    commit('setEmailObject', getConfigValue('email_remerciement_subject'))
                    commit('setEmailPart1', getConfigValue('email_remerciement_part_1'))
                    commit('setEmailPart2', getConfigValue('email_remerciement_part_2'))
                    commit('setCguName', getConfigValue('cgu_link_text'))
                    commit('setCguEndText', getConfigValue('cgu_end_text'))
                    commit("setCadhTitleInterfacePro", getConfigValue("cadh_title_interface_pro")
                    === "1" ? "1" : "0")
                    commit("setOneOfferToShowOptions", getConfigValue("one_offer_to_show_options")
                    === "1" ? "1" : "0")
                    commit("setOneOfferToShowInformations", getConfigValue("one_offer_to_show_informations")
                    === "1" ? "1" : "0")
                    commit('setPdfTitle', getConfigValue('answer_pdf_title'))
                    commit('setHasOffersEnabled', res.body.data.hasOffersEnabled)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit("setHasPaymentOptionsEnabled", res.body.data.hasPaymentOptionsEnabled)
                    commit('setHasCriteriaFamiliesWithNoName', res.body.data.hasCriteriaFamiliesWithNoName)
                    commit('setHasCriteriasWithNoName', res.body.data.hasCriteriasWithNoName)
                    commit('setHasThanksEmailSet', res.body.data.hasThanksEmailSet)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        createInformation({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/information/create", payload).then(
                (res) => {
                    let informations = res.body.data.informations
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigInformations", informations)
                    commit("setCriteriaFamilies", criteriaFamilies)
                })
        },
        updateInformation({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/information/update", payload).then(
                (res) => {
                    let informations = res.body.data.informations
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigInformations", informations)
                    commit("setCriteriaFamilies", criteriaFamilies)
                })
        },
        deleteInformation({commit}, id) {
            return Vue.prototype.$http.delete("adhesion/configs/information/delete/" + id).then(
                (res) => {
                    let informations = res.body.data.informations
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigInformations", informations)
                    commit("setCriteriaFamilies", criteriaFamilies)
                })
        },
        deleteInformations({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/information/multiple-delete", payload).then(
                (res) => {
                    let informations = res.body.data.informations
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigInformations", informations)
                    commit("setCriteriaFamilies", criteriaFamilies)
                })
        },
        createOption({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/option/create", payload).then(
                (res) => {
                    let options = res.body.data.options
                    let levels = res.body.data.levels
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigOptions", options)
                    commit("setOptionLevels", levels)
                    commit('setCriteriaFamilies', criteriaFamilies)
                })
        },
        updateOption({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/option/update", payload).then(
                (res) => {
                    let options = res.body.data.options
                    let levels = res.body.data.levels
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigOptions", options)
                    commit("setOptionLevels", levels)
                    commit('setCriteriaFamilies', criteriaFamilies)
                })
        },
        deleteOption({commit}, id) {
            return Vue.prototype.$http.delete("adhesion/configs/option/delete/" + id).then(
                (res) => {
                    let options = res.body.data.options
                    let levels = res.body.data.levels
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigOptions", options)
                    commit("setOptionLevels", levels)
                    commit('setCriteriaFamilies', criteriaFamilies)
                })
        },
        deleteOptions({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/option/multiple-delete", payload).then(
                (res) => {
                    let options = res.body.data.options
                    let levels = res.body.data.levels
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigOptions", options)
                    commit("setOptionLevels", levels)
                    commit('setCriteriaFamilies', criteriaFamilies)
                })
        },
        createOptionLevel({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/option-level/create", payload).then(
                (res) => {
                    let levels = res.body.data.levels
                    let options = res.body.data.options

                    commit("setOptionLevels", levels)
                    commit("setConfigOptions", options)
                })
        },
        updateOptionLevel({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/option-level/update", payload).then(
                (res) => {
                    let levels = res.body.data.levels
                    let options = res.body.data.options

                    commit("setOptionLevels", levels)
                    commit("setConfigOptions", options)
                })
        },
        deleteOptionLevel({commit}, id) {
            return Vue.prototype.$http.delete("adhesion/configs/option-level/delete/" + id).then(
                (res) => {
                    let levels = res.body.data.levels
                    let options = res.body.data.options

                    commit("setOptionLevels", levels)
                    commit("setConfigOptions", options)
                })
        },
        createPaymentOption({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/payment-option/create", payload).then(
                (res) => {
                    let paymentOptions = res.body.data.payment_options

                    commit("setPaymentOptions", paymentOptions)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit("setHasPaymentOptionsEnabled", res.body.data.hasPaymentOptionsEnabled)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        updatePaymentOption({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/payment-option/update", payload).then(
                (res) => {
                    let paymentOptions = res.body.data.payment_options

                    commit("setPaymentOptions", paymentOptions)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit("setHasPaymentOptionsEnabled", res.body.data.hasPaymentOptionsEnabled)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        deletePaymentOption({commit}, id) {
            return Vue.prototype.$http.delete("adhesion/configs/payment-option/delete/" + id).then(
                (res) => {
                    let paymentOptions = res.body.data.payment_options

                    commit("setPaymentOptions", paymentOptions)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit("setHasPaymentOptionsEnabled", res.body.data.hasPaymentOptionsEnabled)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        updateOffer({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/offer/update", payload).then(
                (res) => {
                    let offers = res.body.data.offers
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigOffers", offers)
                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit('setHasOffersEnabled', res.body.data.hasOffersEnabled)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        createOffer({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/offer/create", payload).then(
                (res) => {
                    let offers = res.body.data.offers
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigOffers", offers)
                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit('setHasOffersEnabled', res.body.data.hasOffersEnabled)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        deleteOffer({commit}, id) {
            return Vue.prototype.$http.delete("adhesion/configs/offer/delete/" + id).then(
                (res) => {
                    let offers = res.body.data.offers
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigOffers", offers)
                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit('setHasOffersEnabled', res.body.data.hasOffersEnabled)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        deleteOffers({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/offer/multiple-delete", payload).then(
                (res) => {
                    let offers = res.body.data.offers
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setConfigOffers", offers)
                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit('setHasOffersEnabled', res.body.data.hasOffersEnabled)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        createPredefinedFamily({commit}, payload) {
            return Vue.prototype.$http.post('adhesion/configs/criteria-family/create-predefined', payload).then(
              (res) => {
                  let criteriaFamilies = res.body.data.criteriaFamilies

                  commit("setCriteriaFamilies", criteriaFamilies)
              }
            )
        },
        createCriteriaFamily({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/criteria-family/create", payload).then(
                (res) => {
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit('setNewFamilyIsDirty', payload.order)
                    commit('setHasCriteriaFamiliesWithNoName', res.body.data.hasCriteriaFamiliesWithNoName)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setHasCriteriaFamiliesWithNoName', res.body.data.hasCriteriaFamiliesWithNoName)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        updateCriteriaFamilyLabel({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/criteria-family/update-label", payload).then(
                (res) => {
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit('setHasCriteriaFamiliesWithNoName', res.body.data.hasCriteriaFamiliesWithNoName)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        updateCriteriaFamilyDescription({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/criteria-family/update-description", payload).then(
                (res) => {
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setCriteriaFamilies", criteriaFamilies)
                })
        },
        deleteCriteriaFamily({commit}, id) {
            return Vue.prototype.$http.delete("adhesion/configs/criteria-family/delete/" + id).then(
                (res) => {
                    let criteriaFamilies = res.body.data.criteriaFamilies
                    let offers = res.body.data.offers
                    let options = res.body.data.options
                    let informations = res.body.data.informations

                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit("setConfigOffers", offers)
                    commit("setConfigOptions", options)
                    commit("setConfigInformations", informations)
                    commit('setHasCriteriaFamiliesWithNoName', res.body.data.hasCriteriaFamiliesWithNoName)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        swapCriteria({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/criteria/swap", payload).then(
                (res) => {
                    const criteria = res.body.data.criteria
                    const familyId = res.body.data.familyId

                    commit("updateFamilyCriterias", [criteria, familyId])
                })
        },
        createCriteria({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/criteria/create", payload).then(
                (res) => {
                    let criteriaFamilies = res.body.data.criteriaFamilies

                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit('setNewCriteriaIsDirty', [payload.cadhCriteriaFamilyId, payload.order])
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setHasCriteriasWithNoName', res.body.data.hasCriteriasWithNoName)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        deleteCriteria({commit}, id) {
            commit('setDeleteCriteriaInProgress', true)

            return Vue.prototype.$http.delete("adhesion/configs/criteria/delete/" + id).then(
                (res) => {
                    let criteriaFamilies = res.body.data.criteriaFamilies
                    let offers = res.body.data.offers
                    let options = res.body.data.options
                    let informations = res.body.data.informations

                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit('setDeleteCriteriaInProgress', false)
                    commit("setConfigOffers", offers)
                    commit("setConfigOptions", options)
                    commit("setConfigInformations", informations)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setHasCriteriasWithNoName', res.body.data.hasCriteriasWithNoName)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        updateCriteria({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/criteria/update", payload).then(
                (res) => {
                    let criteriaFamilies = res.body.data.criteriaFamilies
                    let offers = res.body.data.offers
                    let options = res.body.data.options
                    let informations = res.body.data.informations

                    commit("setCriteriaFamilies", criteriaFamilies)
                    commit("setConfigOffers", offers)
                    commit("setConfigOptions", options)
                    commit("setConfigInformations", informations)
                    commit('setIsConfigured', res.body.data.isConfigured)
                    commit('setHasCriteriasWithNoName', res.body.data.hasCriteriasWithNoName)
                    commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
                })
        },
        updateConfigurationKey({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/key/update", payload).then(
              (res) => {
                  commit('setIsConfigured', res.body.data.isConfigured)
                  commit('setHasThanksEmailSet', res.body.data.hasThanksEmailSet)
                  commit('setMissingRequiredDatasCount', missingRequiredDatasCountCalculation())
              }
            )
        },
        updateName({commit}, payload) {
          return Vue.prototype.$http.post("adhesion/configs/update-name", payload).then(
            (res) => {
                let newName = res.body.data.new_name

                commit("setName", newName)
            }
          )
        },
        getCadhFields({state, commit}) {
            return Vue.prototype.$http.get('adhesion/config/fields').then(res => {
                commit('setglobalFields', Object.values(res.body.data.cadhFields))

                let informations = []

                state.globalFields.forEach(field => {
                    let data = getAdminConfig(field.code)
                    let information = {}

                    if (data !== undefined && data !== null) {
                        information = {
                            label: field.label,
                            code: field.code,
                            check: true,
                            required: data.pivot.required
                        }
                    } else {
                        information = {
                            label: field.label,
                            code: field.code,
                            check: false,
                            required: false
                        }
                    }
                    informations.push(information)
                })

                commit('setAdministrativeDatas', informations)
            })
        },
        updateConfigurationField({commit}, payload) {
            return Vue.prototype.$http.post("adhesion/configs/field/update", payload).then(
                (res) => {
                })
        },
        reorderList({commit}, [
            table,
            configurationId,
            pointerId,
            pointerType,
            moveObjectId,
            filterColumn = null,
            filterId = null]
        ) {
            const payload = {
                table: table,
                configurationId: configurationId,
                pointerId: pointerId,
                pointerType: pointerType,
                moveObjectId: moveObjectId,
                filterColumn: filterColumn,
                filterId: filterId
            }

            return Vue.prototype.$http.post("adhesion/configs/reorder", payload)
        },
    },
}

export default cadhConfig